export default "__VITE_ASSET__LTPs8ztt__"